export default __webpack_public_path__ + "static/media/Logokd.5dfa861a.svg";